import { recaptchaUpdater } from '../../modules/recaptcha';
import Swal from 'sweetalert2';

export const profilesContact = () => {
  recaptchaUpdater('profile');

  $('#form-signin').on('submit', function (e) {
    e.preventDefault();

    if ($('#mobile_phone').val().length < 14) {
      Swal.fire('Atenção!', 'Adicione um telefone válido.', 'error');
      return false;
    } else {
      e.target.submit();
    }
  });
};
